/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CfarItineraryLightFromJSON, CfarItineraryLightToJSON, } from './CfarItineraryLight.js';
import { CfarPriceFromJSON, CfarPriceToJSON, } from './CfarPrice.js';
import { CfarStatusFromJSON, CfarStatusToJSON, } from './CfarStatus.js';
import { PayoutMethodFromJSON, PayoutMethodToJSON, } from './PayoutMethod.js';
/**
 * Check if a given object implements the CfarExerciseCustomerResponse interface.
 */
export function instanceOfCfarExerciseCustomerResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "contractId" in value;
    isInstance = isInstance && "cashRefundAllowance" in value;
    isInstance = isInstance && "hopperRefundCurrency" in value;
    isInstance = isInstance && "payoutMethod" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "contractExpiryDateTime" in value;
    isInstance = isInstance && "itinerary" in value;
    isInstance = isInstance && "cfarPrices" in value;
    return isInstance;
}
export function CfarExerciseCustomerResponseFromJSON(json) {
    return CfarExerciseCustomerResponseFromJSONTyped(json, false);
}
export function CfarExerciseCustomerResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'contractId': json['contract_id'],
        'cashRefundAllowance': json['cash_refund_allowance'],
        'hopperRefundCurrency': json['hopper_refund_currency'],
        'payoutMethod': PayoutMethodFromJSON(json['payout_method']),
        'status': CfarStatusFromJSON(json['status']),
        'contractExpiryDateTime': (new Date(json['contract_expiry_date_time'])),
        'itinerary': CfarItineraryLightFromJSON(json['itinerary']),
        'cfarPrices': (json['cfar_prices'].map(CfarPriceFromJSON)),
    };
}
export function CfarExerciseCustomerResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'contract_id': value.contractId,
        'cash_refund_allowance': value.cashRefundAllowance,
        'hopper_refund_currency': value.hopperRefundCurrency,
        'payout_method': PayoutMethodToJSON(value.payoutMethod),
        'status': CfarStatusToJSON(value.status),
        'contract_expiry_date_time': (value.contractExpiryDateTime.toISOString()),
        'itinerary': CfarItineraryLightToJSON(value.itinerary),
        'cfar_prices': (value.cfarPrices.map(CfarPriceToJSON)),
    };
}
